import { PAUSE_REQUEST, TECHNICAL_GUIDE_STATE, FOLLOWUP_QUESTION } from "./constants";
export const buildRequestData = ({ anomaly, technicalGuideHelpful, technicalGuideLinked, pauseRequest, pauseRequestDuration, comment }, callId) => {
    return {
        callId,
        anomaly,
        technicalGuideState: (technicalGuideLinked !== FOLLOWUP_QUESTION ? technicalGuideLinked : technicalGuideHelpful) ||
            TECHNICAL_GUIDE_STATE.NONE,
        pauseRequest: (pauseRequest !== FOLLOWUP_QUESTION ? pauseRequest : pauseRequestDuration) || PAUSE_REQUEST.NONE,
        comment: comment || null
    };
};
//# sourceMappingURL=buildRequestData.js.map
